module.exports = __webpack_public_path__ + "media/signup-react/amazon-5124ad54.png";